<template>
    <div class="container" v-if="!fetching">
        <div class="section">
            <img class="img" src="https://s20.lgstatic.com/growth/activity/20220707/1657175298571.png">
        </div>
        <div class="ceiling-view" v-if="ceilingType">
            <div class="ceiling-tab" :class="{'ceiling-fixed':ceilingType}">
                <van-tabs v-model="activeTab" :swipe-threshold="4" @click="tabChange">
                    <van-tab v-for="(item, index) in tabList" :key="index" :title="item.stage" >
                    </van-tab>
                </van-tabs>
                <div class="box"></div>
            </div>
        </div>
        <div class="section">
            <img class="img" src="https://s20.lgstatic.com/growth/activity/20220707/1657175423413.png">
        </div>
        <div class="section">
            <img class="img" src="https://s20.lgstatic.com/growth/activity/20220707/1657175466296.png">
        </div>
        <div class="section" id="section1">
            <img class="img" src="https://s20.lgstatic.com/growth/activity/20220707/1657175533863.png">
        </div>
        <div class="txt-main">
            <div class="content">
                <div class="tabViews">
                    <van-tabs v-model="active">
                        <van-tab
                            v-for="(item, index) in stageList"
                            :key="index"
                            :title="item.stage"
                            class="tb"
                        >
                            <div class="tb-title">{{item.title}}</div>
                            <img class="icon" src="https://s21.lgstatic.com/growth/activity/20210310/1615368417803.png">
                            <div class="tb-main" v-for="(v, i) in item.list" :key="i">
                                <div class="v-title">{{v.l_title}}</div>
                                <div class="tb-txt" v-for="(vs, is) in v.l_ls" :key="is">
                                    {{vs}}
                                </div>
                            </div>
                        </van-tab>
                    </van-tabs>
                    <div class="tips-tab">
                        * 具体课程内容以实际课程安排和进度为准
                    </div>
                    <img class="section-btn" @click="JumpFn('领取完整课程安排')" src="https://s20.lgstatic.com/growth/activity/20220708/1657265165002.png" alt="">
                </div>
            </div>
        </div>
        <div class="section" id="section2">
            <img class="img" src="https://s21.lgstatic.com/growth/activity/20220707/1657175823615.png">
        </div>
        <div class="section-view">
            <div class="img-tab">
                <img class="img" :src="imgtabList[imgtabnum]" @click="imgclickFn(imgtabnum)">
            </div>
            <img class="section-btn2" @click="JumpFn('获取更多项目资料')" src="https://s21.lgstatic.com/growth/activity/20220708/1657265470405.png" alt="">
        </div>
        <div class="section" id="section3">
            <img class="img" src="https://s20.lgstatic.com/growth/activity/20221118/1668752846365.jpg">
        </div>
        <!-- <div class="section" id="section4">
            <img class="img" src="https://s21.lgstatic.com/growth/activity/20220707/1657178283707.png">
        </div>
        <div class="section">
            <img class="img" src="https://s21.lgstatic.com/growth/activity/20220707/1657178312589.png">
        </div> -->
        <!-- <div class="section" id="section5">
            <img class="img" src="https://s21.lgstatic.com/growth/activity/20220707/1657178331423.png">
            <div class="current-container-wrap">
                <div class="swiper-container current-container" id="sw-section">
                    <div class="swiper-wrapper current-wraps">
                        <div
                            v-for="(value,inde) in swiperList"
                            :key="inde"
                            class="swiper-slide current-box"
                        >
                            <img class="company" :src="value"/>
                        </div>
                    </div>
                    <div class="swiper-pagination current-pagination" />
                </div>
            </div>
        </div>
        <div class="section">
            <img class="img" src="https://s21.lgstatic.com/growth/activity/20220707/1657178356096.png">
            <div class="sw2" id="sw2">
                <div class="swiper-container current-container2" id="sw-section2">
                        <div class="swiper-wrapper current-wraps">
                            <div
                                v-for="(value,inde) in swiperList2New"
                                :key="inde"
                                class="swiper-slide current-box"
                            >
                                <img class="company" :src="value"/>
                            </div>
                        </div>
                        <div class="swiper-pagination current-pagination" />
                    </div>
            </div>
        </div> -->
        <div class="section">
            <img class="img" src="https://s20.lgstatic.com/growth/activity/20221118/1668752881810.jpg">
        </div>
        <template>
            <button class="footer" @click="JumpFn('名额有限立即抢占')">
                <div class="box10-right img pay-btn-wrapper">
                  <div class="pay-btn">
                    好课速享 马上抢占
                  </div>
                </div>
                <img class="H5activityIcon" v-if="activity.isShow" :src="activity.H5icon">
                <div class="img-box">
                    <img
                        class="img-btns"
                        src="https://s21.lgstatic.com/growth/activity/20210831/1630410757988.png"
                    >
                </div>
                <FooterPoup
                    :id="38"
                    :isDcsj="false"
                />
            </button>
        </template>
        <RetainModal
            :visible="retainModalVisible"
            @removeHash="removeHash"
            pageId="1qzq"
        />
    </div>
</template>

<script>
import { handleJumpUrl } from '../../../uitl/getParam.js';
import Swiper from 'swiper';
import 'swiper/dist/css/swiper.min.css';
import { Tab, Tabs } from 'vant';
import activity from '../../../common/activity';
Vue.use(Tab);
Vue.use(Tabs);
import List from './data.js'
import RetainModal from '../../../components/RetainModal/index.vue'
import { postIsBuyCourse } from '../../../service/api'
import { getEduAppVersion, isBiggerThanSpecifiedVersion } from '../../../uitl/getVersion'
// ios
// window.appBeforeGoBack = function () {
//     window.location.hash = 'showModal'
//     return 0
// }
// // android
// if (isBiggerThanSpecifiedVersion(getEduAppVersion(), '2.3.4')) {
//     window.appBeforeUnLoaded = function () {
//         window.location.hash = 'showModal'
//         return true
//     }
// }
export default {
    name: 'JavaJaGouShiH5',
    data() {
        return {
            activity,
            List,
            sectionData:[],
            swiperList1:[],
            swiperList2:[],
            ceilingType:false,//吸顶tab
            activeTab:0,
            imgtabnum: 0,
            modalVisable:false,
            moadlData:{},
            tabList:[],
            stageList:[],
            retainModalVisible: false,
            canShowModal: false,
            imgtabList: [
                "https://s20.lgstatic.com/growth/activity/20220707/1657177615499.png",
                "https://s20.lgstatic.com/growth/activity/20220707/1657177912868.png"
            ],
            swiperList: [
                "https://s21.lgstatic.com/growth/activity/20220707/1657178927941.png",
                "https://s20.lgstatic.com/growth/activity/20220707/1657178940296.png",
                "https://s21.lgstatic.com/growth/activity/20220707/1657178949004.png",
                "https://s21.lgstatic.com/growth/activity/20220707/1657178957530.png",
            ],
            swiperList2New: [
                "https://s20.lgstatic.com/growth/activity/20220707/1657179362428.png",
                "https://s21.lgstatic.com/growth/activity/20220707/1657179378071.png",
                "https://s21.lgstatic.com/growth/activity/20220707/1657179387957.png",
                "https://s21.lgstatic.com/growth/activity/20220707/1657179400058.png",
                "https://s21.lgstatic.com/growth/activity/20220707/1657179409775.png"
            ],
            addressIdsMap: {
                "课程体系": "u1tzr",
                "实战项目": "v1tzs",
                "就业服务": "w1tzt",
                "用户评价": "x1tzu",
                "领取完整课程安排": "y1tzv",
                "获取更多项目资料": "z1tzw",
                "名额有限立即抢占": "a1tzx"
            }
        };
    },
    components: {
        [Tab.name]: Tab,
        [Tabs.name]: Tabs,
        RetainModal
    },
    computed: {
        swiperType() {
            return (type)=>{
                return type ==='1' ? this.swiperList1 : this.swiperList2;
            }
        }
    },
    created () {
        this.saLogin();
    },
    mounted() {
        let dataList = this.List.data;
        const {section, swiperList1,swiperList2} = dataList.h5;
        const {tabList, stageList} = dataList;
        this.sectionData = section;
        this.swiperList1 = swiperList1;
        this.swiperList2 = swiperList2;
        this.tabList = tabList;
        this.stageList = stageList;
        // this.watchHashChange()
        setTimeout(()=>{
            // this.eduPlatTrack('WebView', { page_id: '1qzq' ,'test_version':'B版-实验版'});
            this.platTrack('h5pv', {
                page_id: '1qzq',
            })
            this.swiperInit()
            this.renderSwipers()
            window.addEventListener('scroll', this.scrollTopFn)
        },500)
    },
    destroyed () {
        window.removeEventListener('scroll', this.scrollTopFn)
    },
    methods: {
        imgclickFn(imgtabnum) {
            this.imgtabnum = imgtabnum === 1 ? 0 : 1
        },
        scrollTopFn() {
            let scroll = document.documentElement.scrollTop || document.body.scrollTop;
            this.ceilingType = scroll > 370 ? true : false; //吸顶tab
            let arr = [
                "section1",
                "section2",
                "section3",
                // "section4",
                // "section5"
            ]
            arr.forEach((item,index) =>{
                if(document.getElementById(item).getBoundingClientRect().top < 100) {
                    this.activeTab = index
                }
            })
        },
        tabChange(val,title) {
            let arr = [
                "#section1",
                "#section2",
                "#section3",
                // "#section4",
                // "#section5"
            ]
            this.$el.querySelector(arr[val]).scrollIntoView(true);
            let scroll = document.documentElement.scrollTop || document.body.scrollTop;
            document.documentElement.scrollTop = scroll - 50
            document.body.scrollTop = scroll - 50
            // this.eduPlatTrack('WebButtonClick', {
            //     'page_id': '1qzq',
            //     'button_name': title
            // });
            this.platTrackClickFn(title)
        },
        clickImage(type){
            if(type==='btn'){
                this.JumpFn();
            }
        },
        JumpFn(str) {
            // let button_name = '领取详细课程大纲'
            // if(name && typeof name ==='string'){
            //     button_name = name
            // }
            // this.eduPlatTrack('WebButtonClick', {
            //     'page_id': '1qzq',
            //     'button_name': button_name
            // });
            str && this.platTrackClickFn(str)
            setTimeout(() => {
              window.location.href = 'https://t.lagou.com/DR25RsRss=A65';
            }, 200)
        },
        watchHashChange() {
            const that = this
            window.addEventListener('hashchange', function(e) {
                postIsBuyCourse().then(res => {
                    if (res.state == 1) {
                        if (res.content) {
                            window.lgBridge && window.lgBridge.request('close', {}, (res) => {});
                        } else {
                            that.canShowModal = !res.content
                            if (window.location.hash == '#showModal' && that.canShowModal) {
                                that.retainModalVisible = true
                            }
                        }
                    }
                })
            })
        },
        removeHash() {
            this.retainModalVisible = false
            this.canShowModal = false
            window.location.hash = ''
        },
        getTags(item){
            this.modalType = 'text';
            this.fixedBody();
            this.modalVisable = true;
            this.moadlData = item
        },
        closeModal(){
            this.looseBody();
            this.modalVisable = false;
        },
        fixedBody() {
            this.selfTop = document.body.scrollTop || document.documentElement.scrollTop;
            document.body.style.cssText += 'position:fixed;overflow: hidden;width:100%;height: auto;top: -' + this.selfTop + 'px';
        },
        looseBody() {
            var body = document.body;
            body.style.overflow = 'auto';
            body.style.height = 'auto';
            body.style.position = '';
            document.body.scrollTop = document.documentElement.scrollTop = parseInt(this.selfTop);
        },
        swiperInit() {
            let option = {
                direction: 'horizontal',
                loop: true,
                speed: 500,
                pagination: '.current-pagination',
                paginationType: 'bullets',
                paginationClickable: true,
                autoplayDisableOnInteraction: false,
                autoplay: 2800,
                slidesPerView: 'auto',
                centeredSlides: true,
                spaceBetween: 16,
            };

            this.$nextTick(() => {
                const swiper = new Swiper('.current-wrap', option);
            })

        },
        renderSwipers() {
            let that = this;
            let option = {
                speed: 300,
                autoplay: 3000,
                loop: true,
                autoplayDisableOnInteraction: false,
                slidesPerView: 'auto',
                spaceBetween: 10,
            };
            const swiper1 = new Swiper('.current-container', option);
            let option2 = {
                speed: 300,
                autoplay: 3000,
                loop: true,
                autoplayDisableOnInteraction: false,
                slidesPerView: 'auto',
                spaceBetween: 10
            };
            const swiper2 = new Swiper('.current-container2', option2);
        },
        platTrackClickFn(name) {
            this.platTrack('h5click', {
                page_id: '1qzq',
                address_id: this.addressIdsMap[name]
            })
        }
    }
};
</script>

<style lang='less' scoped>
.container {
    width: 100%;
    background: #F8F8F8;
    padding-bottom: 150px;
    .section {
        position: relative;
        width: 100%;
        background: #f8f8f8;
        .img {
            width: 100%;
            display: block;
        }
        .img-container{
            position: relative;
            .btn-style{
                position: absolute;
                text-align: center;
                bottom: 0;
                left: 50%;
                height: 88px;
                width: auto;
                transform: translate(-50%,-50%);
            }
        }
        .padding-container{
            min-height: 200px;
        }
        .activityImg {
            position: absolute;
            z-index: 11;
            top: 0;
            right: 0;
            width: 157px;
            height: 158px;
            img {
                width: 100%;
            }
        }
        .current-container {
            width: 100%;
            position: absolute;
            height: 202px;
            bottom: 230px;
            .current-wraps {
                width: 582px;
                position: absolute;
                padding-left: 10px;
                .current-box {
                    width:100% !important;
                    margin-left: 20px;
                    img {
                        width: 100%;
                    }
                }
            }
        }
        .wrap {
            width: 690px;
            height: 647px;
            .swiper-wrapper {
                width:100% !important;
                img {
                    width: 100%;
                }
            }
        }
    }
    .ceiling-view {
        width: 100%;
        // height: 94px;
        // margin: 0px 0 40px;

        .ceiling-tab {
            position: relative;
            width: 100%;
            height: 94px;
            background: #FFFFFF;
            box-shadow: 0px 6px 8px 0px rgba(71, 68, 85, 0.08);
            z-index: 33;
            // /deep/ .van-tabs__wrap--scrollable{
            // height: 94px;
            // }
            .box {
                position: absolute;
                top: 0;
                right: 0;
                width: 60px;
                height: 94px;
                background: linear-gradient(270deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 100%);
            }
            /deep/ .van-tabs__nav {
                position: relative;
            }
            // /deep/ .van-tabs__wrap {
            //     height: 94px;
            // }
            /deep/ .van-tab {
                position: relative;
                width: 200px;
                height: 94px;
                color: #32355C;
                font-size: 30px;
                font-weight: 400;
            }
            /deep/.van-tab--active {
                box-sizing: border-box;
                color: #32355C;
                font-weight: 400;
                &::before{
                    content: '';
                    width: 32px;
                    height: 32px;
                    background: url('https://s20.lgstatic.com/growth/activity/20210923/1632364298791.png') no-repeat center;
                    background-size: 100% 100%;
                    position: absolute;
                    left: 16px;
                    top:50%;
                    transform: translateY(-50%);
                    transition-duration: 0.3s;
                }
                .van-tab__text {
                    padding-left: 24px;
                }
            }
            /deep/ .van-tabs__line {
                // bottom: 40px;
                background: linear-gradient(309deg, #FF5A37 0%, #991010 100%);
                width: 160px;
                height: 6px;

            }
        }
        .ceiling-fixed {
            position: fixed;
            top: 0;
            left: 0;
            z-index: 30;
        }
    }

    .layer {
        position: fixed;
        z-index: 9;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        background: rgba(0, 0, 0, 0.6);
        display: none;
        &.active {
            display: block;
        }
    }
    .modal {
        position: fixed;
        bottom: 180px;
        z-index: 10;
        display: flex;
        justify-content: center;
        .modal-content {
            width: 750px;
            height: 0;
            opacity: 0;
            transition: height .3s linear;
            overflow-y: scroll;
            &.active {
                opacity: 1;
                height: 962px;
                overflow: hidden;
            }
            &.active-img {
                opacity: 1;
                height: 662px;
                overflow: hidden;
            }
            background: #fff;
            border-radius: 18px 18px 0 0;
            position: relative;
            margin-right: 45px;
            box-sizing: border-box;
        }
        .close {
            width: 42px;
            height: 42px;
            background: url("https://s21.lgstatic.com/growth/activity/20210402/1617356751440.png") no-repeat;
            background-size: 42px 42px;
            position: absolute;
            right: 30px;
            top: 30px;
            border-radius: 50%;
            z-index: 1;
        }
        .title {
            margin-top: 82px;
            width: 658px;
            font-size: 32px;
            line-height: 40px;
            margin-bottom: 41px;
            padding-left: 45px;
            font-weight: bold;
            &-dot {
                width: 5px;
                height: 5px;
                border-radius: 5px;
                background: #FA4000;
            }
            .sub-title{
                color: #C69C6D;
                font-size: 26px;
                margin-top: 8px;
            }
        }
        .content {
            height: 755px;
            overflow-y: scroll;
        }
        .content-title {
            margin-bottom: 20px;
            font-weight: bold;
            color: #191F34;
            position: relative;
            padding-left: 47px;
            font-size: 26px;
            line-height: 28px;
            padding-right: 30px;
            &:before {
                content: '';
                width: 8px;
                height: 8px;
                background: #C69C6D;
                border-radius: 8px;
                position: absolute;
                left: 25px;
                top: 11px;
            }
        }
        .content-desi {
            margin-bottom: 48px;
            color: #5E6476;
            font-size: 26px;
            padding-left: 48px;
            padding-right: 30px;
        }
        .content-img {
            width: 100%;
            height: 100%;
            overflow-y: scroll;
        }
        .content-img img{
            width: 100%;
            margin: 0px auto;
            display: block;
        }
    }
    .tips-box {
        position: absolute;
        top: 0px;
        left: 0;
        width: 100%;
        height: 100%;
        .tips-img {
            position: absolute;
            top: 0px;
            left: 0px;
            animation: left 2.2s infinite linear;
            display: block;
            height: 100%;
        }
    }
    .footer {
        position: fixed;
        background-color:transparent;
        border: none;
        bottom: -1px;
        z-index: 999;
        width: 100%;
        box-shadow: 0px -12px 12px 0px rgba(156, 157, 185, 0.22);

        .pay-btn-wrapper {
          box-sizing: border-box;
          width: 750px;
          height: 158px;
          background-color: #fff;
          padding-top: 26px;
          .pay-btn {
            width: 90%;
            margin: 0 auto;
            height: 87px;
            line-height: 87px;
            color: #fff;
            border-radius: 30px;
            background-image: linear-gradient(90deg,  #fe5686, #ff8d5f);
          }
        }
        .img {
            width: 100%;
            display: block;
        }
        .H5activityIcon {
            position: absolute;
            top: -50px;
            right: 42px;
            width: 209px;
        }
        .img-box {
            position: absolute;
            top: 10px;
            left: 0;
            width: 100%;
            height: 100px;
        }
        .img-btns {
            position: absolute;
            top: 0px;
            left: 0px;
            animation: left 2s infinite linear;
            width: 224px;
            height: 120px;
        }
    }

    @keyframes left {
        0% {
            left: -50%;
        }
        50% {
            left: 100%;
        }
        100% {
            left: 200%;
        }
    }
    .current-container-wrap {
        position: absolute;
        bottom: 10px;
        left: 30px;
        width: calc(100% - 56px);
        height: 490px;
        box-sizing: border-box;
        overflow: hidden;
        .current-container {
            width: 100%;
            height: 490px;
            position: absolute;
            bottom: 0;
            left: 0;
            .current-wraps {
                width: 582px;
                position: absolute;
                padding-left: 10px;
                .current-box {
                    width:100% !important;
                    margin-left: 20px;
                    img {
                        width: 100%;
                    }
                }
            }
        }
    }
}


.container {
    width: 100%;
    padding-bottom: 145px;
}
.txt-main {
    width: 100%;
    background: #f8f8f8;
    overflow: hidden;
    padding-bottom: 60px;
    .title {
        width: 664px;
        height: 49px;
        display: block;
        margin: 30px 0 0 30px;
    }
}
.btn1 {
    height: 83px;
}
.btn2 {
    height: 118px;
}
.btn3 {
    height: 129px;
}
.btn4 {
    height: 92px;
}
.content {
    width: 694px;
    margin: 0 auto;
}
/deep/ .tabViews {
    position: relative;
    width: 694px;
    border-radius: 11px;
    .section-btn {
        position: absolute;
        bottom: -39px;
        left: 50%;
        width: 488px;
        height: 98px;
        transform: translateX(-50%);
    }
    .tips-tab {
        position: absolute;
        bottom: 60px;
        right: 50px;
        color: #666;
        font-size: 14px;
    }
    .van-tabs__wrap--scrollable .van-tabs__nav {
        background: #FF9D69;
    }
    .van-tabs {
        padding-bottom: 20px;
    }
    .van-tab {
        width: 150px;
        color: #fff;
        font-size: 26px;
        font-weight: 400;
    }
    .van-tabs--line .van-tabs__wrap {
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
    }
    .van-tabs__line {
        background-color: #fff;
        bottom: 0.5rem;
        height: 4px;
    }
    .tb {
        width: 100%;
        padding-bottom: 80px;
        // box-shadow: 0px 23px 37px 0px rgba(248, 115, 0, 0.09);
        background-color: #fff;
        border-radius: 0 0 11px 11px;
        .tb-title {
            font-size: 26px;
            font-family: SourceHanSansSC-Regular, SourceHanSansSC;
            font-weight: 400;
            color: #333333;
            text-align: center;
            padding-top: 30px;
        }
        .icon {
            width: 619px;
            height: 3px;
            display: block;
            margin: 18px auto 10px;
        }
        .tb-main {
            width: 100%;
        }
        .v-title {
            height: 37px;
            background: linear-gradient(180deg, #FFC492 0%, #FE6C11 100%);
            border-radius: 0px 18px 18px 0px;
            padding: 0 14px 0 30px;
            margin: 10px 0 20px;
            line-height: 37px;
            color: #fff;
            font-size: 21px;
            display: inline-block;
            font-family: SourceHanSansSC-Regular, SourceHanSansSC;
        }
        .tb-txt {
            box-sizing: border-box;
            width: 100%;
            color: #666;
            font-size: 21px;
            padding:4px 30px 4px;
        }
    }
}

.img-box {
    width: 100%;
    img {
        font-size: 0;
        display: block;
        width: 100%;
    }
    .activityImg {
        position: absolute;
        z-index: 11;
        top: 0;
        right: 0;
        width: 157px;
        height: 158px;
        img {
            width: 100%;
        }
    }
}
.swiper-main {
    width: 100%;
    background-size: 100% 100%;
    box-sizing: border-box;
    background: #f8f8f8;
}
.swiper-main1{
    height: 9.5rem;
}
.swiper-main2{
    height: 11rem;
}
/deep/ .current-wrap {
    width: 8.507rem;
    height: 100%;
    .swiper-wrapper {
        width: 8.507rem;
        height: 100%;
        .swiper-slide {
            width: 100%;
            height: 100%;
            img {
                width: 100%;
            }
        }
    }
    .swiper-pagination-bullet{
        width: 0.173rem;
        height: 0.173rem;
        background: rgba(240,114,52,.4);
        border-radius: 50%;
        opacity: 1;
        &-active{
            border-radius: 0.173rem;
            width: 0.48rem;
            background: #F07234;
        }
    }
}
.section-view {
    position: relative;
    padding-bottom: 40px;
    .section-btn2 {
        position: absolute;
        bottom: 10px;
        left: 50%;
        width: 488px;
        height: 98px;
        transform: translateX(-50%);
    }
    // height: 1000px;
    background-color: #F2F2FA;
    .img-tab {
        width: 688px;
        // height: 992px;
        margin: 0 auto;
        // position: relative;
        &.w100 {
            width: 100%;
        }
        .img {
            width: 100%;
            // position: absolute;
            top: 0;
            left: 0;
        }
    }
    .btn-img {
        display: block;
        margin: 0 auto 40px;
        width: 464px;
        background-color:transparent;
        border: none;
        position: relative;
        overflow: hidden;
        top: -44px;
        &-2 {
            top: -44px;
        }
        .botton_img {
            width: 100%;
            display: block;
        }
    }
}
.sw2 {
    position: absolute;
    top: 100px;
    left: 28px;
    width: calc(100% - 28px);
    height: 674px;
    padding: 0 28px;
    box-sizing: border-box;
    img {
        width: 357px;
    }
    .current-container2 {
        width: 100%;
        height: 674px;
        position: absolute;
        bottom: 0;
        left: 0;
        .current-wraps {
            width: 357px;
            position: absolute;
            padding-left: 10px;
            .current-box {
                width:357px !important;
                // margin-left: 20px;
                img {
                    width: 100%;
                }
            }
        }
    }
}

</style>
